import { render, staticRenderFns } from "./cargoMultiUserSelect.vue?vue&type=template&id=2640e695&"
import script from "./cargoMultiUserSelect.vue?vue&type=script&lang=js&"
export * from "./cargoMultiUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2640e695')) {
      api.createRecord('2640e695', component.options)
    } else {
      api.reload('2640e695', component.options)
    }
    module.hot.accept("./cargoMultiUserSelect.vue?vue&type=template&id=2640e695&", function () {
      api.rerender('2640e695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoMultiUserSelect.vue"
export default component.exports